import React from 'react';

const Home = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#27355c' }}>
        <center>
          <img src="/coworking-itaguai-1.png" alt="Your Logo" width="180" />
        </center>
      </nav>
      <br />
      <h1>Em breve agendamento on-line!</h1>
    </div>
  );
};

export default Home;